import { render, staticRenderFns } from "./heaher.vue?vue&type=template&id=24097130&"
import script from "./heaher.vue?vue&type=script&lang=js&"
export * from "./heaher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports